module.exports = __webpack_public_path__ + "img/agency-cover.03b956ca.jpg";